const {Component} = require("react");
const router = require("app/services/router");
const axios = require("axios");
const logger = require("app/services/logger");
const Modal = require("app/components/modals/Modal");
const env = require("app/services/env");
const Trans = require('app/components/trans/Trans')
const React = require("react");

class Widget extends Component {

	constructor(props) {
		super(props);

		this.state = {
			response: null
		};
	}

	submit = (day = 0, funeral) => {

		let value = this.input.value;
		if(funeral){
			value = this.inputFuneral.value;
		}

		if (!value) return;

		let cart_id = env.get("checkout.cart.products.guid");

		axios
			.post(router.route("api.deliveryTime.check", {zipcode: value, addDays: day, funeral: funeral}), {cart_id: cart_id})
			.then(response => {
				this.setState({response: response.data});
				this.modal.open();
			})
			.catch(error => {
				logger.error(error);
			});
	}

	_handleTodayClickFuneral = () => {
		this.submit(0, 1);
	}

	_handleTodayClick = () => {
		this.submit(0, 0);
	}

	_handleTomorrowClick = () => {
		this.submit(1, 1);
	}

	_handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			this.submit();
		}
	}

	renderResponse() {
		if (!this.state.response) {
			return;
		}

		const {success, message, time, status, extra} = this.state.response;
		const className = "response " + (success ? "success" : "error");
		const timeHtml = time ? (<span className="time"> {time}</span>) : null;

		return (
			<div className={className}>
				<span className="message">{message}</span>
				{timeHtml}
				{(status === 'uncertain' || status === 'impossible') ? (
					<span className="message">
						<br />
						<br />
                      <Trans> <b>Husk:</b> Du kan stadig nå at bestille blomster med levering næste dag (mandag-lørdag).</Trans>
					</span>
				) : null}
				{(extra != "") ? (
					<span className="message">
						<br />
						<br />
                      <i><Trans>*forudsat at ordren opfylder <a href={extra}>salgs- og leveringsbetingelserne</a></Trans></i>
					</span>
				): null}
			</div>
		);
	}

	renderInput(funeral) {
		if(funeral){
			return(
				<div className="input funeral-check">
					<input ref={input => this.inputFuneral = input} type="text" id="delivery-time-checker-zipcode-input-funeral" 
								pattern="\d*" placeholder={ translate("Indtast postnr.")} />
                  <button className="call-to-action btn funeral_today" onClick={this._handleTodayClickFuneral}><Trans>Levering i dag</Trans></button>
                  <button className="call-to-action btn funeral_tomorrow" onClick={this._handleTomorrowClick}><Trans>Levering i morgen</Trans></button>
					<span className="text-placeholder"></span>
				</div>
			)
		} else {
			return(
				<div className="input">
					<input ref={input => this.input = input} type="text" id="delivery-time-checker-zipcode-input"
								 pattern="\d*" placeholder={ translate("Indtast postnr.")} />
                  <button className="call-to-action btn" onClick={this._handleTodayClick}><Trans>Levering i dag</Trans></button>
					<span className="text-placeholder"></span>
				</div>
			)
		}
	}

	renderDeliveryText(funeral){
		if(funeral){
			return (
              <Trans><p>Tjek om dine begravelsesblomster kan nå ud i dag / i morgen</p></Trans>
			)
		} else {
			return (
              <Trans> <p>Tjek om din bestilling kan leveres i dag.</p> </Trans>
			)
		}
	}

	render() {
		return (
			<div className="delivery-time-checker" id="timecheckers">
				{this.renderDeliveryText(false)}
				{this.renderInput(false)}
				<Modal ref={el => this.modal = el}>
					{this.renderResponse()}
				</Modal>
			</div>
		);
	}

}

module.exports = Widget;
